/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AreaModel } from '../../models/area-model';
import { AreaResponse } from '../../models/area-response';

export interface PutApiAreaV1Id$Json$Params {

/**
 * The unique identifier of the area to update.
 */
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The updated area data.
     */
    body?: AreaModel
}

export function putApiAreaV1Id$Json(http: HttpClient, rootUrl: string, params: PutApiAreaV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaResponse>> {
  const rb = new RequestBuilder(rootUrl, putApiAreaV1Id$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AreaResponse>;
    })
  );
}

putApiAreaV1Id$Json.PATH = '/private/v1/areas/{id}';
